export const getArticleStatusStyle = (status) => {
  const base = {
    borderRadius: "5px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: "24px",
    padding: "0 8px",
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: 500,
    color: "#405261",
  };

  switch ((status || '').toLowerCase()) {
    case 'published':
      return { ...base, border: '1px solid #148DFD', background: '#F3FBFF', width: '80px' };
    case 'pendingreview':
    case 'pending review':
      return { ...base, border: '1px solid #FA8C16', background: '#FFF7E6', width: '112px' };
    case 'archived':
      return { ...base, border: '1px solid #FF4D4F', background: '#FFF1F0', width: '72px' };
    case 'draft':
      return { ...base, border: '1px solid #FADB14', background: '#FFFBE6', width: '56px' };
    case 'new':
      return { ...base, border: '1px solid #52C41A', background: '#F6FFED', width: '48px' };
    default:
      return base;
  }
};
